<template>
  <div class="overseaProduct_wrapper">
      <div class="check_Top">
        <div class="check_header">
           <el-steps :active="active" finish-status="success">
            <el-step :title="$t('other.a2855')"></el-step>
            <el-step :title="$t('other.a2856')"></el-step>
            <el-step :title="$t('other.a2759')"></el-step>
            </el-steps>
        </div>
        <div class="check_desc">
           <span class="sec_item">
                <el-select @change="getStoreItemAndGroup()"  v-model="dataParams.storeId" :placeholder="$t('other.a914')" >
                    <el-option v-for="item in storesOptions" :key="item.value" :label="item.label" :value="item.value" >
                    </el-option>
                </el-select>
                <el-input style="width:350px;margin-left:10px" clearable @keydown.native="checkNull()" v-model="dataParams.cusCode" :placeholder="$t('other.a2859')"></el-input>
                <el-button style="margin:0 10px" type="primary" @click="searchByParams()">{{$t('other.a27')}}</el-button>
           </span>
           <div>
                <el-button v-show="active !== 0"  style="margin-right:20px"  type="primary" @click="active--">{{$t('other.a2857')}}</el-button>
                <el-button  style="margin-right:20px"  type="primary" @click="nestStupet()">{{$t('other.a2858')}}</el-button>
                <el-button  @click="goBack()"  type="primary"><i class="iconfont icon-fanhui-"></i> {{$t('other.a605')}}</el-button>
           </div>
        </div>
      </div>
      
      <!-- 产品列表 -->
      <div v-if="active == 0" class="overseaProduct_list">
          <div class="overseaProduct_item"  v-for="(item,index) in overDataList" :key="index">
              <div style="margin:5px ">
                  <!-- <el-checkbox v-model="item.checked" @change="chooseItem(item,index)"></el-checkbox> -->
                  <el-radio v-model="radio" :label="index+1" @change="chooseItem(item,index)"></el-radio>
              </div>
              <div class="pic_box">
                  <img style="width:100%" :src="item.image ? item.image : item.storeItems[0].image" />
              </div>
              <div class="title_overseaProduct">{{item.groupName}}</div>
              <div class="item_desc_parentsku">{{$t('other.a249')}}{{item.itemSku ? item.itemSku : $t('other.a260')}}</div>
              <div class="item_desc">{{$t('other.a660')}}：{{item.storeItems.length}}</div>
              <div class="item_desc">{{$t('other.a1349')}}：{{item.total}}</div>
          </div>
      </div>
      <div style="margin-top:140px;padding:0 20px" v-if="active ==  1">
          
          <div class="basic_info">
            <div class="title">{{$t('other.a735')}}</div>
            <div class="basic_detail">
                <el-form :model="ruleForm" :rules="rules"  ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item :label="$t('other.a66')" >
                               <el-upload
                                class="avatar-uploader"
                                :headers="token"
                                action="https://erp.shopsbu.com/service/access/upload"
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess"
                                >
                                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                    </el-form-item>
                    <el-form-item :label="$t('other.a1901')" prop="groupName">
                        <el-input v-model="ruleForm.groupName"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('other.a735')" prop="itemSku">
                        <el-input style="width:300px" v-model="ruleForm.itemSku"></el-input>
                    </el-form-item>

                    <el-form-item :label="$t('other.a1285')" prop="categories">
                        <div v-clickOutSide="handleClose" >
                        <el-input  v-model="ruleForm.categories" :placeholder="$t('other.a1285')" @focus="showCaetgory=!showCaetgory"></el-input>
                         <div v-if="showCaetgory" class="cateGory_wrapper"  >
                            <ul  class="first_wrapper">
                                <div class="category_title">{{$t('other.a482')}}</div>
                                <li class="first_category active" v-for="(item,index) in categoryList" :key="index" @click="cateGory(item,1)">
                                    <span>{{item.categoryName}} ({{item.zhName}})</span>
                                </li>
                            </ul>
                            <ul v-if="secondCategory.length"  class="second_wrapper">
                                <div class="category_title">{{$t('other.a483')}}</div>
                                <li class="second_category  active" v-for="(itemTwo,indexOne) in secondCategory" :key="indexOne" @click="cateGory(itemTwo,2)">
                                   <span> {{itemTwo.categoryName}} ({{itemTwo.zhName}})</span>
                                     <!-- <i v-if="itemTwo.childrens.length" class="el-icon-caret-right"></i> -->
                                </li>
                            </ul>
                            <ul v-if="thiryCategory.length"  class="three_wrapper">
                                <div class="category_title">{{$t('other.a484')}}</div>
                                <li class="three_category  active" v-for="(itemThree,indexOne) in thiryCategory" :key="indexOne" @click="cateGory(itemThree,3)">
                                    <span>{{itemThree.categoryName}} ({{itemThree.zhName}})</span>
                                     <!-- <i v-if="itemThree.childrens.length" class="el-icon-caret-right"></i> -->
                                </li>
                            </ul>
                            <!-- <ul v-if="fourCategory.length"  class="four_wrapper">
                                <div class="category_title"> {{$t('other.a1378')}}</div>
                                <li class="four_category  active" v-for="(itemfour,indexOne) in fourCategory" :key="indexOne" @click="cateGory(itemThree,4)">
                                    {{itemfour.categoryName}}
                                </li>
                            </ul> -->
                         </div>
                        </div>
                    </el-form-item>

                   
                  
                </el-form>
            </div>

           
        </div>
         <div class="basic_info">
            <div class="title">{{$t('other.a2139')}}</div>
            <div class="basic_detail">
                <el-form :model="ruleForm"  ref="ruleForm"  class="demo-ruleForm">
               
                     <el-form-item label="" prop="name">
                       <el-table
                            :data="ruleForm.storeItems"
                            
                           > 
                            <el-table-column
                                prop="date"
                                label="cusCode"
                                width="100"
                               >
                                <template slot-scope="props">
                                    <span>{{props.row.cusCode}}</span>
							    </template>
                            </el-table-column>
                            <el-table-column
                                prop="date"
                                :label="$t('other.a2139')" 
                               >
                                <template slot-scope="props">
                                    <el-input v-model="props.row.skuName" :placeholder="$t('other.a2816')"></el-input>
							    </template>
                            </el-table-column>
                            <el-table-column
                                prop="date"
                                :label="$t('other.a2815')"
                               >
                                <template slot-scope="props">
                                    <el-input v-model="props.row.variationName" :placeholder="$t('other.a2817')"></el-input>
							    </template>
                            </el-table-column>
                             <el-table-column
                                prop="date"
                                :label="$t('other.a2137')"
                               >
                               <template slot-scope="scope"  slot="header">
                                      <div style="margin-bottom:10px">
                                          <span style="padding-right:5px">{{$t('other.a2860')}}</span>
                                         <el-tooltip style="padding-right:5px"   effect="light" :content="$t('other.a2861')" placement="bottom">
                                         <i class="el-icon-question" style="font-size:22px"></i>
                                         </el-tooltip>
                                      </div>
                                      <div>
                                          <el-input size="mini" style="width:80px" @blur="setPrice(0)" v-model="stockValue" :placeholder="$t('other.a307')"></el-input>
                                      </div> 
								   </template>
                                <template slot-scope="props">
                                   <div class="rmbBox"><span >¥</span> <el-input style="margin-left:10px" @change="calcNum(props.row)" v-model="props.row.cost" ></el-input></div>
							    </template>
                            </el-table-column>

                            <el-table-column
                                prop="date"
                                :label="$t('other.a2863')"
                                width="100"
                               >
                               <template slot-scope="scope"  slot="header">

										 <span style="padding-right:5px">{{$t('other.a2863')}}</span>
                                         <el-tooltip style="padding-right:5px"   effect="light" :content="$t('other.a2862')" placement="bottom">
                                         <i class="el-icon-question" style="font-size:22px"></i>
                                        </el-tooltip>
										
								   </template>
                                <template slot-scope="props">
                                    <span>{{props.row.paid}}</span>
							    </template>
                            </el-table-column>
                            <el-table-column
                                prop="date"
                               >
                                <template slot-scope="scope"  slot="header">

                                    <span style="padding-right:5px">{{$t('other.a2864')}}</span>
                                    <el-tooltip style="padding-right:5px"   effect="light" :content="$t('other.a2865')" placement="bottom">
                                    <i class="el-icon-question" style="font-size:22px"></i>
                                     </el-tooltip>
										
								</template>
                             
                                <template slot-scope="props">
                                    <span>{{props.row.storeNum}}</span>
							    </template>
                            </el-table-column>

                            <el-table-column>
                                <template slot-scope="scope"  slot="header">
                                    <div style="margin-bottom:10px">
                                        <span style="padding-right:5px">{{$t('other.a2867')}}</span>
                                        <el-tooltip style="padding-right:5px"   effect="light" :content="$t('other.a2866')" placement="bottom">
                                        <i class="el-icon-question" style="font-size:22px"></i>
                                       </el-tooltip>
                                    </div>
                                    <el-input size="mini" style="width:80px" @blur="setPrice(2)" v-model="stockName" :placeholder="$t('other.a307')"></el-input>
                                </template>
                                <template slot-scope="props">
                                    <el-input v-model="props.row.numStock" ></el-input>
							    </template>
                            </el-table-column>
                        </el-table>

                       
                    </el-form-item>
                    
                </el-form>
            </div>
        </div>

      </div>
      <!-- 分页器 -->
    <div v-show="active == 0 " class="Pager">
        <el-pagination
        @size-change="handleSizeChangeTwo"
        @current-change="handleCurrentChangeTwo"
        :current-page="currentPage"
        :page-sizes="[15, 20, 50, 100]"
        :page-size="50"
        layout="total, sizes, prev, pager, next, jumper"
        :total="overDataTotal"
        >
        </el-pagination>
    </div>
      
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import utils from '../../../utils/utils'
import api from '../../../api/api'
import userStoreItemsApi from '../../../api/moudles/userStoreItems'
export default {
data(){
return{
    userId:JSON.parse(localStorage.getItem('userInfo')).userId,
    stores:JSON.parse(localStorage.getItem('userInfo')).stores,
    storesOptions:[],
    overDataList:[],
    showCaetgory:false,
    categoryList:[],
    secondCategory:[],
    categoryIdList:[],
    thiryCategory:[],
    cateList:[],
    radio:'',
    stockName:null,
    categories:'',
    stockValue:'',
    active:0,
    overDataTotal:0,
    currentPage:1,
    targetList:[],
    imageUrl:'',
    dataParams:{
        component: true,
        cusCode: "",
        offset: 50,
        page: 0,
        sellerId: JSON.parse(localStorage.getItem('userInfo')).userId,
        storeId: null,
        userId: JSON.parse(localStorage.getItem('userInfo')).userId,
    },
    ruleForm:{
        groupName:'',
        categories:null,
        categoryId:null,
        itemSku:'',
        storeItems:[]
    },
    rules:{
        groupName:[
            {required:true,message: this.$t('other.a2868'), trigger: 'blur' }
        ],
         itemSku:[
            {required:true,message: this.$t('other.a2869'), trigger: 'blur' }
        ],
        //  categories:[
        //     {required:true,message: '请选择商品的类目！', trigger: 'blur' }
        // ],
    },

    token:{
        token:JSON.parse(localStorage.getItem('userInfo')).token
    },
    refresh:false,
}
},

 computed: {
    ...mapState({
      userName: (state) => state.shopaccess.userInfo.userName,
     
    }),
    targetListCopy(){
        let list=this.targetList.filter(p => {
            if(p.checked){
                return p
            }
        })

        return list

        
    }




    
},
directives:{
    clickOutSide:{
        bind:function(el, binding , vnode){
            function documentHandler(e){
                if(el.contains(e.target)){
                return false
                }

                if(binding.expression){
                    binding.value(e)
                }
            }
            el._vueClickOutside_ =documentHandler
            document.addEventListener('click',documentHandler)
        },

        unbind:function (el,binding) {
            document.removeEventListener('click',el._vueClickOutside_)
        }

    },
    el_selectLoadmore:{
        bind(el,binding){
            let self=this
            const SELECTWRAP_DOM =el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
           
            SELECTWRAP_DOM.addEventListener('scroll', function () {
                const condition = this.scrollHeight - this.scrollTop-20 <= this.clientHeight
                if (condition) binding.value()
            })
        }
    }
},
watch:{
    refresh(){
        if(this.refresh){
            this.getOverseaData(this.dataParams)
        }
    },
    categories(){
        this.ruleForm.categories=this.categories
        console.log(this.ruleForm)
    }
   
},


created(){
    this.storesOptions=utils.getStoresByStoreType(1)
    this.getStores()
    this.dataParams.storeId=this.storesOptions[0].value
    this.getOverseaData(this.dataParams)
    this.init()
},
destroyed(){
    utils.cleanStorageData()
},
methods:{

  getStores(){
        let stores=JSON.parse(localStorage.getItem('userInfo')).stores
        let options=[]
        stores.forEach(p => {
            if((p.storeType == 1 ||  p.storeType == 2) && p.isUsed){
                let ttp=p.storeType == 1 ? this.$t('other.a2723') : this.$t('other.a2724')
                options.push({
                    label:p.storeName +'(' + ttp  + ')',
                    value:p.storeId
                })
            }
        })
        this.storesOptions=options
  },  
 checkNull(){
     if(this.dataParams.cusCode){
         setTimeout(() => {
            console.log(this.dataParams.cusCode)
            if(!this.dataParams.cusCode){
                this.refresh=true
            }
        },300)
     }
     
 },   
 calcNum(item){
     let storelist=JSON.parse(localStorage.getItem('userInfo')).stores
     let chargeRule=storelist.find(item => item.storeId == this.$route.query.store).chargeRule

     item.paid=item.cost-(item.cost*chargeRule.supplierRatio/100)
     console.log(item)

 },
 setPrice(index){
     if(index == 0){
        let storelist=JSON.parse(localStorage.getItem('userInfo')).stores
        let chargeRule=storelist.find(item => item.storeId == this.$route.query.store).chargeRule
        console.log(chargeRule)
         this.ruleForm.storeItems.forEach(p => {
             p.cost =Number(this.stockValue)
             p.paid=p.cost-(p.cost*chargeRule.supplierRatio/100)
         })
     }

     if(index == 2){
         this.ruleForm.storeItems.forEach(p => {
             p.numStock =this.stockName
         })
     }


 },

 bingModel(){
     this.$route.push({
         path:''
     })
 },
 init(){
     if(this.$route.query.store){
        
         let obj=this.stores.find(p => {
             if(p.storeId == this.$route.query.store){
                 return p
             }
         })
         api
         .getCategoryByCountry({
             country:obj.storeAddress
         })
         .then(res => {
             if(res.code === 200){
                 console.log('类目',res.data)
                 this.categoryList=res.data
             }
         })

         console.log('obj',obj)
     }
 },

 chooseItem(item,index){
     console.log(index)
    item.checked=true
    this.targetList=[]
    this.targetList.push(item)
 },

 cateGory(item,index){
        // this.$message.warning(item.has_children)
        
        console.log(item)
        if(index == 1){
           this.secondCategory=item.childrens
           this.thiryCategory=[]
           this.cateList[index-1]=item.categoryName
           this.categoryIdList[index-1]=item.categoryId
           this.cateList.splice(index,1)
           this.categoryIdList.splice(index,1)
           
        }else if(index == 2){
            this.thiryCategory=item.childrens
            this.cateList[index-1]=item.categoryName
            this.categoryIdList[index-1]=item.categoryId
            this.cateList.splice(index,1)
            this.categoryIdList.splice(index,1)
        }else if(index == 3){
            this.cateList[index-1]=item.categoryName
            this.categoryIdList[index-1]=item.categoryId
            this.categoryIdList.splice(index,1)
        }else if(index == 4){
            this.fourCategory=item.childrens
            this.cateList[index-1]=item.categoryName
            this.categoryIdList[index-1]=item.categoryId
            this.categoryIdList.splice(index,1)
        }
        this.categories=this.cateList.join(' / ')
        if(item.childrens == null){
            this.showCaetgory=false
              this.thiryCategory=[]
              this.fourCategory=[]
               this.secondCategory=[]
              

            this.ruleForm.categoryId=this.categoryIdList[this.categoryIdList.length-1]    

        }

        console.log(this.ruleForm)
        console.log(this.categoryIdList)
        console.log(this.cateList)
    },
 nestStupet(){
    console.log(this.targetListCopy)
    if(this.active == 1){
        //生成模版数据
       let list=this.ruleForm.storeItems.filter(p => {
        if(!p.cost){
                return p
            }
        })
        if(list.length){
            this.$message.warning(this.$t('other.a2870'))
            return 
        }
        let falg=false
        this.ruleForm.storeItems.forEach(i => {
            if(i.stock >= 0 && i.storeNum < i.numStock){
                falg=true
            
            }
        })
        if(falg){
            this.$message.warning(this.$t('other.a2871'))
            return
        }

        this.$confirm(this.$t('other.a2872'),this.$t("other.a142"),{
            confirmButtonText:this.$t('other.a145'),
            cancelButtonText: this.$t('other.a146'),
            type: 'warning'
        }).then(() => {
            this.ruleForm.categoryId=this.categoryIdList[this.categoryIdList.length-1]
            this.ruleForm.storeId=this.$route.query.store
            this.ruleForm.groupId=null
            this.ruleForm.image=this.ruleForm.image ? this.ruleForm.image : this.ruleForm.storeItems[0].image

            api
            .addStoreItemGroupNotProduct(this.ruleForm)
            .then(res =>  {
                if(res.code === 200) {//导入分销仓
                    let groupId=res.data.groupId
                    let storeId=res.data.storeId
                    let newRuleForm=res.data
                    let cusCodeList=res.data.storeItems.map(p => {return p.cusCode})

                    console.log('cusCodeList',cusCodeList)
                    this.$message.success(this.$t('other.a2873'))
                    api
                        .getCorrelation(cusCodeList)
                        .then(res => {
                        if(res.code === 200 ){
                             console.log('导入分销仓后查找绑定的对应关系',res.data)
                             console.log('741',this.ruleForm)
                             res.data.forEach(p => {
                                 
                                 p.numStock=this.ruleForm.storeItems.find(item => item.cusCode === p.correlation.cusCode).numStock
                             })
                             let list=res.data.map(p => {
                                 return {
                                     sourceCusCode:p.correlation.cusCode,
                                     targetCusCode:p.cusCode,
                                     userId:this.userId,
                                     num:Number(p.numStock)
                                 }
                             })
                             console.log('list',list)
                            api
                            .batchTransferStoreNum(list)
                            .then(res => {
                                if(res.code === 200 ){
                                //  this.$message.success(this.$t('other.a2874'))
                                }else{
                                this.$message.warning(res.msg)
                                }
                            })
                        }else{
                            this.message.warning(res.msg)
                            }
                        })

                    setTimeout(() => {
                        //绑定对应关系 
                        this.$message.success(this.$t('other.a2874'))

                        //新建数据源，并绑定模版
                                 api
                                    .getItemAttribute({itemId:this.targetList[0].storeItems[0].items[0].itemId})
                                    .then(res => {
                                        if(res.code === 200) {
                                        res.data.logistics.forEach(i => {
                                            i.itemId=null
                                        })
                                        let obj={}
                                        if(res.data.tier.error === 'error_banned'){//如果是单品
                                            obj.price=res.data.item.price
                                            obj.stock=this.ruleForm.storeItems[0].numStock
                                            obj.cusCode=newRuleForm.storeItems[0].cusCode
                                        }else{
                                            obj.tiers=res.data.tier.tier_variation.map((p,index) => {
                                                return {
                                                    images:p.images_url,
                                                    name:p.name,
                                                    optionArray:this.ruleForm.storeItems.map(i => {
                                                        return i.skuName
                                                    }),
                                                    position:index
                                                }
                                            })
                                            console.log('ruleForm.storeItems',this.ruleForm.storeItems)
                                            obj.variations=[]
                                            res.data.tier.variations.forEach((p,index) => {
                                            
                                                obj.variations.push({
                                                    cusCode:null,
                                                    price:null,
                                                    variationSku:obj.tiers[0].optionArray[p.tier_index[0]],
                                                    stock:'',
                                                    tierIndex:p.tier_index
                                                })
                                            
                                            
                                            
                                            })
                                            obj.price=null
                                            obj.stock=null

                                            obj.variations.forEach((p,index) => {
                                                this.ruleForm.storeItems.forEach(k => {
                                                    if(p.variationSku == k.skuName){
                                                        p.stock =k.numStock
                                                    }
                                                })
                                                if(newRuleForm.storeItems.length){
                                                    newRuleForm.storeItems.forEach(k => {
                                                    if(p.variationSku == k.skuName){
                                                        p.price =k.cost
                                                        p.cusCode=k.cusCode
                                                    }
                                                })
                                                }
                                            })
                                            
                                        }
                                        obj.itemSku=res.data.item.itemSku
                                        obj.productShops=[]
                                        obj.name=res.data.item.name
                                        obj.categoryId=res.data.item.categoryId
                                        obj.status=res.data.item.status
                                        obj.weight=res.data.item.weight
                                        obj.packageHeight=res.data.item.packageHeight
                                        obj.packageLength=res.data.item.packageLength
                                        obj.packageWidth=res.data.item.packageWidth
                                        obj.sourceUrl=''
                                        obj.modelId=null
                                        obj.productId=null

                                        if(!res.data.images.length ){
                                            obj.images=[{
                                                positions:0,
                                                image:res.data.item.image

                                            }]
                                        }else{
                                            
                                            obj.images=res.data.images.map(p => {
                                                return{
                                                    positions:p.positions,
                                                    image:p.image
                                                }
                                            })

                                        }
                                        obj.description=res.data.item.description
                                        obj.condition=res.data.item.condition
                                        obj.attributes=res.data.attributes
                                        obj.logistics=res.data.logistics
                                        obj.country='ROOT'
                                        obj.userId=this.userId

                                        console.log('obj',obj)


                                        api
                                        .updataProduct(obj)
                                        .then(res => {
                                            if(res.code === 200){
                                                console.log('新增模版',res.data)
                                                obj.modelId=res.data.productId
                                                api
                                                .updateProductId({
                                                groupId:groupId,
                                                storeId:storeId,
                                                productId:res.data.productId,
                                                userId:this.userId
                                                })
                                                .then(res => {
                                                    if(res.code === 200){
                                                        console.log('仓库产品绑定模版',res.data)
                                                        this.$message.success(this.$t('other.a2502'))
                                                        
                                                        setTimeout(() => {
                                                            this.goBack()
                                                        }, 1000);
                                                    }else{
                                                        this.$message.warning(res.msg)
                                                    }
                                                })
                                            
                                                
                                            }else{
                                                this.$message.warning(res.msg)
                                                
                                            }
                                        })

                                    

                                        console.log('obj',obj)
                                        console.log('1541',res.data)
                                    }
                            })

                        

                    },2000)

                    
                    

                    
           





                    // let flag=this.ruleForm.storeItems.find(p => p.numStock !== 0)
                    // let tarGet=JSON.parse(JSON.stringify(this.ruleForm.storeItems))
                    // let list=[]
                    // res.data.storeItems.forEach(p => {
                    //     let num=tarGet.find(item => item.skuName == p.skuName)
                    
                    //         list.push({
                    //             sourceCusCode:num.cusCode,
                    //             targetCusCode:p.cusCode,
                    //             num:parseInt(num.numStock),
                    //             userId:this.userId
                    //         })
                    // })
                    // console.log(flag)
                    // if(flag){
                    //     this.$message.success('正在执行分拔库存操作，请稍等！')
                    //     setTimeout(() => {
                    //         let count=0
                    //         list.forEach(p => {
                    //             api
                    //             .transferStoreNum(p)
                    //             .then(res => {
                    //                 if(res.code === 200){
                    //                     count++
                    //                     if(count === list.length){
                    //                         this.$message.success('成功导入分销仓！')
                    //                     }
                    //                 }else{
                    //                     this.$message.warning(res.msg)
                    //                 }
                    //             })
                    //         })
                            
                        
                    //     },700)
                    // }
                   
                   
                   


                }else{
                    this.$message.warning(res.msg)
                }
            })
            console.log(this.ruleForm)
        })

        return 
    }
    if(!this.targetListCopy.length){
        this.$message.warning(this.$t('other.a2407'))
        return
    }
    this.ruleForm=this.targetListCopy[0]
    this.imageUrl=this.targetListCopy[0].image ?  this.targetListCopy[0].image : this.targetListCopy[0].storeItems[0].image
    this.overDataList.forEach(p => {
        p.checked=false
    })
    this.radio=-1

    let originListCopy=JSON.parse(JSON.stringify(this.categoryList)) 
               
                if(this.ruleForm.categoryId){
                    console.log(this.ruleForm.categoryId)
                    let id=this.ruleForm.categoryId
                    let list=[]
                    this.categoryIdList=[]

                    originListCopy.forEach(p => {
                        p.childrens.forEach(k => {
                            if(k.categoryId === id){
                                list.push(p.categoryName)
                                list.push(k.categoryName)
                                this.categoryIdList.push(p.categoryId)
                                this.categoryIdList.push(k.categoryId)
                            }else{
                                if(k.childrens !== null){
                                     k.childrens.forEach(i => {
                                   
                                    if(i.categoryId === id){
                                         list.push(p.categoryName)
                                         list.push(k.categoryName)
                                         list.push(i.categoryName)
                                         this.categoryIdList.push(p.categoryId)
                                         this.categoryIdList.push(k.categoryId)
                                         this.categoryIdList.push(i.categoryId)
                                    }
                                })
                                }
                               
                            }
                        })
                    })
                    console.log('list',list)
                    this.categories=list.join(' / ')
                   
                    
                    
                    
                }

    this.active++
 },
 goBack(){
        if(this.$route.query.from == 'distributeStoer'){
            this.$router.push('/distributeProduct/myselfproduct')
        }
 },

 searchByParams(){
     console.log(this.dataParams)
     this.getOverseaData(this.dataParams)
 },
 handleClose(){
        this.showCaetgory=false
    },

 handleAvatarSuccess(res, file) {
    // console.log(file.response.data)
    // this.imageUrl = URL.createObjectURL(file.raw);
    // this.ruleForm.image=file.response.data
    // console.log(this.ruleForm)
    },

 handleAvatarSuccess(res, file) {
    console.log(file.response.data)
    this.imageUrl = URL.createObjectURL(file.raw);
    this.ruleForm.image=file.response.data
    console.log(this.ruleForm)
    },

getStoreItemAndGroup(){
    this.getOverseaData(this.dataParams)
},
 getOverseaData(params){
     userStoreItemsApi
     .getStoreItem(params)
     .then(res => {
         if(res.code === 200){
             console.log('海外仓库数据',res.data)
             this.refresh=false
             res.data.groups.forEach(p => {
                 p.checked=false
                 p.total=0
                 p.storeItems.forEach(k => {
                     k.numStock=0
                     k.paid=0
                     p.total+=k.storeNum
                    
                 })
             })
             this.overDataList=res.data.groups
             this.overDataTotal=res.data.count
         }
     })
 },

 //控制每页显示订单条数
handleSizeChangeTwo(val) {
    console.log(`每页 ${val} 条`);
    this.dataParams.offset=parseInt(`${val}`)
    this.handleCurrentChangeTwo()
    
    
},
//显示当前第几页
handleCurrentChangeTwo(val) {
    
    this.dataParams.page=`${val}` == "undefined" ? 0 : (parseInt(`${val}`) - 1) * this.dataParams.offset;
    this.currentPage=parseInt(`${val}`)
    console.log(this.dataParams.page,this.dataParams.offset);
    this.getOverseaData(this.dataParams)
    
},

}
}

</script>
<style lang="scss" scoped>
@import "~@assets/scss/mixins";

.overseaProduct_wrapper{
    // flex: 1;
    // margin: 60px 0 0 228px;
    background-color: rgba(226, 222, 222, 0.5);
    min-height: 100vh;

/deep/ .el-radio__inner {
    width: 20px;
    height: 20px;
}
    
   /deep/ .el-checkbox__inner {
    width: 20px;
    height: 20px;
  }

  /deep/ .el-checkbox__inner::after {
    height: 10px;
    left: 7px;
    width: 4px;
    font-weight: bold;

    
  }

  .basic_info{
       
        background-color: #fff;
        padding: 0 16px;
        margin-top: 20px;

        .avatar-uploader .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }
        .avatar-uploader .el-upload:hover {
            border-color: #409EFF;
        }
        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 120px;
            height: 120px;
            line-height: 120px;
            text-align: center;
            border: 1px dashed #66b1ff;
        }

        .rmbBox{
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .avatar {
            width: 120px;
            height: 120px;
            display: block;
        }

        .cateGory_wrapper{
            position: relative;
            box-shadow:0 5px 5px -3px #606266;
            height: 450px;
            

            
            .first_wrapper{
                position: absolute;
                top: 0;
                left: 0;
                width: 350px;
                height: 450px;
                overflow-y: scroll;
                z-index: 99;
                background-color: #fff;
               

                .first_category{
                    cursor: pointer;
                    padding: 0 10px;
                    border-bottom: 1px solid #eee;
                }
                
            
            }

            

            .second_wrapper{
                position: absolute;
                top: 0;
                left: 350px;
                width: 350px;
                height: 450px;
                overflow-y: scroll;
                z-index: 99;
                background-color: #fff;
               

                .second_category{
                    cursor: pointer;
                    padding: 0 10px;
                    border-bottom: 1px solid #eee;
                }
               

            }

            .three_wrapper{
                position: absolute;
                top: 0;
                left: 700px;
                width: 350px;
                height: 450px;
                overflow-y: scroll;
                z-index: 99;
                background-color: #fff;

                 .three_category{
                    cursor: pointer;
                    padding: 0 10px;
                    border-bottom: 1px solid #eee;
                }
               

            }

            .four_wrapper{
                position: absolute;
                top: 0;
                left: 1050px;
                width: 350px;
                height: 450px;
                overflow-y: scroll;
                z-index: 99;
                background-color: #fff;

                 .four_category{
                    cursor: pointer;
                    padding: 0 10px;
                    border-bottom: 1px solid #eee;
                }
               

            }


            .category_title{
                position: relative;
                top: 0;
                left: 0;
               
            }

          

            .active:hover{
                background-color: #eee;
            }
        }



      

        .title{
            height: 40px;
            line-height: 40px;
            font-size: 20px;
            font-weight: 500;
            letter-spacing: .02em!important;
            font-family: Roboto,sans-serif!important;
            border-bottom: 1px solid #eee;
        }

        .basic_detail{
            padding: 15px 0;
            
        }
     
    }

    .Pager{
    position: fixed;
		bottom: 0;
		left: 225px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	
  }
  


    .overseaProduct_list{
        margin-top: 145px;
        display: flex;
        flex-wrap: wrap;
       
       

        .overseaProduct_item{
            box-sizing: border-box;
            margin: 8px 3px;
            background-color: #fff;
            border-radius: 5px;

        }
        
     


        .pic_box{
            width: 150px;
            height: 150px;
            overflow: hidden;
            border-radius: 5px;
        }
   

        .title_overseaProduct{
            width:148px;
            height: 1.7rem;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
            overflow: hidden;
            padding: 2px;
            font-size: 12px
            
        }

        .item_desc{
          width:148px;
          height: 14px;
          overflow:hidden;
          text-overflow: ellipsis;
          font-size: 14px;
          padding:5px 0
        }

        .item_desc_parentsku{
          color: #F56C6C;
          width:148px;
          height: 14px;
          overflow:hidden;
          text-overflow: ellipsis;
          font-size: 14px;
          padding:5px 0
        }
    }
    

    .check_desc{
        @include flex-between();
        margin: 10px 0;

        .check_desc_item{
            margin:0 10px;
        }

        .sec_item{
            @include flex-start()
        }
    }

    .check_desc:nth-child(3){
        display: flex;
        justify-content: space-between;
        padding-right: 15px;
        align-items: center;
    }


    .check_Top{
        position: fixed;
        z-index: 99;
        top: 50px;
        width: calc(100% - 228px);
        background-color: #fff;
        border-bottom: 1px solid #eee;
      

    }
    .check_header{
        padding: 10px 15px;
    }

    .check_table{
      
        margin-top: 105px;
        width: calc(100% - 15px);

        .check_title{
            font-size: 18px;
            font-weight: bold;
            padding: 10px 0;
        }
    }

    .textarea{
        margin-bottom: 100px;
        margin-top: 10px;
    }
  
}

</style>